import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Button } from 'antd';

// assets
import { ArrowRightOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// containers
import UploadMedia from 'mobile/containers/UploadMedia';
import UploadCameraMedia from 'mobile/containers/UploadCameraMedia';

// global user
import { useGetLocalUser } from 'engine/Contexts/User.context';

function MediaForm({
  formData,
  isEdit,
  currentStep,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);

  const localUser = useGetLocalUser()();

  const [isDisabled, setIsDisabled] = useState(false);
  const [AbsFormMedia] = Form.useForm();

  const [mediaFiles, setMediaFiles] = useState([]);
  const [uploading, setUploading] = useState(false);


  /* 
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData && formData.hasOwnProperty('media') && formData?.media.length > 0) {
      AbsFormMedia.resetFields();
      // go to preview file
      goToStep !== undefined && goToStep(currentStep+1);  

      setIsDisabled(false);
    }
  }, [formData]);

  // check media files if have it submit form
  useEffect(() => { 
    if (mediaFiles.length > 0 && uploading) {
      AbsFormMedia.setFieldsValue({
        media: [...mediaFiles],
      });
      AbsFormMedia.submit();
    }
  }, [mediaFiles, uploading]);
  

  const onFinish = values => {
    result(values);
    nextStep !== undefined && nextStep();
    AbsFormMedia.resetFields();
  };


  const noProofHandle = () => {
    const formValues = AbsFormMedia.getFieldsValue();
    if (formValues.hasOwnProperty('media')) {
      delete formValues.media;
      result(formValues);
      gotToResumeStep();
    } else {
      result(values);
      gotToResumeStep();
    }
    AbsFormMedia.resetFields();
  }

  const gotToResumeStep = () => {
    if (goToStep !== undefined) {
      const resumeStep = isEdit && localUser?.role == 'parent' ? 3 : 6;
      goToStep(resumeStep);
    }
  }

  const uploadMediaFiles = (data) => setMediaFiles(data); 

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormMedia}
        className="form-absence__form form-proof__form"
        name="form_absence_media"
        initialValues=""
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <div className="form-proof">

          <UploadCameraMedia
            name="media"
            media={mediaFiles}
            setProgress={setUploading}
            uploadChange={uploadMediaFiles} />
          
          <UploadMedia
            name="media"
            media={mediaFiles}
            setProgress={setUploading}
            uploadChange={uploadMediaFiles} />

          <Button
            className="proof-option"
            //form="form_absence_media"
            //htmlType="submit"
            onClick={noProofHandle}
            disabled={isDisabled}
          >
            <CustomIcons className="proof-option__icon" type="no-proof" />
            <span className="proof-option__description">
              {`Je n'ai pas de justificatif`}
            </span>
            <ArrowRightOutlined className="proof-option__arrow" />
          </Button>
        </div>

        <div className="absence-actions-wrapper">
          <Button
            className="btn-previous"
            onClick={prevStep}
          >
            Précédent
          </Button>
        </div>
      </Form>
    </div>
  );
}

MediaForm.defaultProps = {};
MediaForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(MediaForm);
